import React, { useState, useEffect } from "react";
import { Redirect,useHistory } from "react-router-dom";
import axios from "axios";
import { LoyaltyTwoTone, TurnedInTwoTone } from "@material-ui/icons";
import Grid from "@material-ui/core/Grid";
import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import TextField from "@material-ui/core/TextField";
import Autocomplete from "@material-ui/lab/Autocomplete";
import { makeStyles, withStyles } from "@material-ui/core/styles";
import Button from "@material-ui/core/Button";
import { format } from "date-fns";
import DateFnsUtils from "@date-io/date-fns";
import Breadcrumbs from "@material-ui/core/Breadcrumbs";
import Typography from "@material-ui/core/Typography";
import FormLabel from "@material-ui/core/FormLabel";
import MUIDataTable from "mui-datatables";
import { NavLink } from "react-router-dom";
import Modal from "@material-ui/core/Modal";
import Backdrop from "@material-ui/core/Backdrop";
import Fade from "@material-ui/core/Fade";
import MessageBox from "../../components/MessageBox/MessageBox";
import Preloader from "../../components/Preloader/Preloader";
import { get_cookies, isLoggedIn } from "../../components/Cookies/Cookies";
import LoadingOverlay from "react-loading-overlay";
import numeral from "numeral";

import Input from "@material-ui/core/Input";
import PopUpModal from "../../components/Modal/PopUpModal";
// import WholesalesInformation from "./WholsalesInformation copy";
const useStyles = makeStyles((theme) => ({
  title: {
    marginTop: 0,
  },
  field: {
    width: "100%",
    marginBottom: "1rem",
  },
  autoComplete: {
    width: "100%",
    marginTop: "0",
    marginBottom: "0.5rem",
  },
  date: {
    width: "100%",
    marginBottom: "1rem",
  },
  buttonContainer: {
    textAlign: "right",
  },
  modal: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    width: "100%",
    maxWidth: "600px",
    margin: "0 auto",
  },
  paper: {
    backgroundColor: theme.palette.background.paper,
    border: "2px solid #000",
    boxShadow: theme.shadows[5],
    padding: theme.spacing(2, 4, 3),
    width: "800px",
  },
  button: {
    textAlign: "right",
    marginTop: "30px",
    "& .MuiButton-containedPrimary": {
      marginRight: "10px",
    },
    "&:disabled": {
      backgroundColor: "#d3d3d3 !important",
      color: "#9e9e9e !important",
    },
  },

  buttonMarginRight: {
    marginRight: "0.5rem",
  },
}));

const CustomButton = withStyles(() => ({
  root: {
    "&:disabled": {
      backgroundColor: "gray !important", 
      color: "white !important",
    },
  },
}))(Button);

const WholesalesInformation = (props) => {
  const history = useHistory();
  const classes = useStyles();
  const navid = props.location.pageInfo ? props.location.pageInfo.navid : "";
  const CurrentPage = props.location.pageInfo
    ? props.location.pageInfo.navname
    : "";
  const TransactionInformation = props.location.transactionInfo
    ? props.location.transactionInfo
    : "";
  const isCORelease = props.location.isCORelease
    ? props.location.isCORelease
    : "";
  const PackageDetails = props.location.PackageDetails
    ? props.location.PackageDetails
    : "";
  //ApiData Component useState SOF
  const [packages_list, loadPackagesDropdown] = useState([]);
  const [location_dropdown, loadLocationDropdown] = useState([]);
  const [package_details, setPackage_Details] = useState({});
  const [branchIdNo, setBranchIdNo] = useState(get_cookies("branchidno"));
  const [branchCurcode, setBranchCurcode] = useState(get_cookies("curcode"));
  const [nextPagePath, setnextPagePath] = useState("");
  const [isLoaded, setisLoaded] = useState(false);
  const [isPackageCountisGood, setPackageCountisGood] = useState("");
  const [defaultLocation, setSelectedWareHouse] = useState({
    id: TransactionInformation.warehouse,
    description: TransactionInformation.warehouse_desc,
  });
  //Loading overlay
  const [showOverlay, setShowOverlay] = useState(false);
  const [overLayMsg, setOverlayMsg] = useState(false);
  const [modalOpen, setModalOpen] = useState(false);
  const [messageType, setMessageType] = useState("info");
  const [popUpMessage, setPopUpMessage] = useState("");
  //Loading overlay EOF

  const [btnDisabled, setBtnDisabled] = useState(true);
  const headers = {
    "Content-Type": "multipart/form-data",
    "Access-Control-Allow-Origin": process.env.REACT_APP_API_URL,
  };
  const get_warehouse = () => {
    //get data for warehouse/location dropdown
    const apiUrl = process.env.REACT_APP_API_URL + "warehouse";
    const formData = new FormData();
    formData.append("form_data", "");
    axios.post(apiUrl, formData, { headers: headers }).then((res) => {
      loadLocationDropdown(res.data.warehouse);
    });
  };
  // const get_setpackages = () => {
  // 	//get data for warehouse/location dropdown

  // 	const form_data = {
  // 		branchidno: branchIdNo,
  // 		curcode:get_cookies('curcode'),
  // 		promo_id:navid
  // 	}
  // 	const formData = new FormData();
  // 	formData.append('form_data', JSON.stringify(form_data));
  // 	const apiUrl = process.env.REACT_APP_API_URL+'get_single_promocode';
  // 	axios.get(apiUrl, formData, {headers:headers}).then((res) => {
  // 		console.log('3',res);
  // 		// loadPackagesDropdown(res.data.packages_list);
  // 	});
  // };
   const get_idno_package = async () => {
    //get data for single supplier
    setisLoaded(false);
    await axios
      .get(process.env.REACT_APP_API_URL + "check_package", {
        params: {
           idno: TransactionInformation.activationcode,
                jc_u_idno: get_cookies('branchidno'),
        },
      })
      .then((res) => {

      loadPackagesDropdown(res.data.data);
      setTotalCount(res.data.total)
      })
      .catch((error) => {
        // console.log(error.message);
      });
  };
  const get_setpackages = async () => {
    //get data for single supplier
    setisLoaded(false);
    await axios
      .get(process.env.REACT_APP_API_URL + "get_single_promocode_wholesale", {
        params: {
          country: get_cookies("country"),
          atype: props.location.pageInfo.atype,
        },
      })
      .then((res) => {
        // console.log("77", res.data.info.packagetype);
        setPackage_Details(res.data.info);

        axios
          .get(
            process.env.REACT_APP_API_URL +
              "get_product_package_list_wholesale",
            {
              params: {
                country: get_cookies("country"),
                atype: props.location.pageInfo.atype,
                //supplier_id
              },
            }
          )
          .then((res) => {
            // console.log("24", res.data.data.info);
            // loadPackagesDropdown(res.data.data.info);
            setisLoaded(true);
          })
          .catch((error) => {
            // console.log(error.message);
          });
      })
      .catch((error) => {
        // console.log(error.message);
      });

    // await axios.get(process.env.REACT_APP_API_URL+'get_supplier_items_list', {
    // 	params:{
    // 		supplier_id: supid,  //supplier_id
    // 	}
    // }).then((supplier_item_result)=>{
    // 	setSupplierItem(supplier_item_result.data.data);
    // }).catch((error)=>{
    // //console.log(error.message);
    // });
  };
  // const get_setpackages = () => {
  // 	//get data for warehouse/location dropdown
  // 	console.log('l',props)
  // 	const form_data = {
  // 		// branchidno: branchIdNo,
  // 		// navid:navid
  // 		promotypename: 12,
  // 		promotype: 53,
  // 		jc_user_id_no: branchIdNo,
  // 	}
  // 	const formData = new FormData();
  // 	formData.append('form_data', JSON.stringify(form_data));
  // 	const apiUrl = process.env.REACT_APP_API_URL+'get_product_package_list';
  // 	axios.post(apiUrl, formData, {headers:headers}).then((res) => {
  // 		loadPackagesDropdown(res.data.packages_list);
  // 	});
  // };
  const validate_packageitem_count = (package_obj, packageid) => {
    //get data for warehouse/location dropdown
    const form_data = {
      package_obj: package_obj,
      packageid: packageid,
      branchidno: branchIdNo,
    };
    const formData = new FormData();
    formData.append("form_data", JSON.stringify(form_data));
    const apiUrl = process.env.REACT_APP_API_URL + "checkiteminventory";
    axios.post(apiUrl, formData, { headers: headers }).then((res) => {
      if (res.data.is_insufficient == "no") {
        console.log("yesyes");
        return "yes";
      } else {
        setShowMsgBox(true);
        setMsg(
          "Insufficient inventory quantity for the chosen Wholesale Set. You may contact our head office for your repurchase of products."
        );
        setMsgType("warning");
        setTimeout(() => {
          setShowMsgBox(false);
        }, 3000);
      }
    });
  };
  const validate_packagecount = () => {
    setBtnDisabled(true);
    //get data for warehouse/location dropdown
    props.history.push(nextpage);
    // const form_data = {
    //   selectedpackages: TABLE_DATA,
    //   navid: navid,
    // };
    // const formData = new FormData();
    // formData.append("form_data", JSON.stringify(form_data));
    // const apiUrl = process.env.REACT_APP_API_URL + "validate_packagecount";
    // axios.post(apiUrl, formData, { headers: headers }).then((res) => {
    //   console.log("2323", res.data);
    //   if (res.data.result.success == 1) {
    //     // if(isCORelease == ""){
    //     props.history.push(nextpage);
    //     // }else{
    //     // props.history.push(nextpageEncoding);
    //     // }
    //   } else {
    //     setShowMsgBox(true);
    //     setMsg(res.data.result.message);
    //     setMsgType("warning");
    //     setTimeout(() => {
    //       setShowMsgBox(false);
    //     }, 3000);
    //   }
    // });
  };
  const validate_packagecount2 = (packages) => {
    //get data for warehouse/location dropdown
    const form_data = {
      selectedpackages: packages,
      navid: navid,
    };
    const formData = new FormData();
    formData.append("form_data", JSON.stringify(form_data));
    const apiUrl = process.env.REACT_APP_API_URL + "validate_packagecount";
    axios.post(apiUrl, formData, { headers: headers }).then((res) => {
      if (res.data.result.success == 1) {
        isPackageCountisGood("yes");
      } else {
        setShowMsgBox(true);
        setMsg(res.data.result.message);
        setMsgType("warning");
        setTimeout(() => {
          setShowMsgBox(false);
        }, 3000);
        isPackageCountisGood("no");
      }
    });
  };

  const check_if_have_item = () => {
    setisLoaded(true);
    const apiUrl = process.env.REACT_APP_API_URL + "does_have_item";
    const form_data = {
      navid: navid,
      curcode: branchCurcode,
    };
    const formData = new FormData();
    formData.append("form_data", JSON.stringify(form_data));
    axios.post(apiUrl, formData, { headers: headers }).then((res) => {
      if (res.data.success == 1) {
        // console.log('333',res);
        if (res.data.noofpackages > 0) {
          setnextPagePath(res.data.nextpagepath);
        } else {
          const itemNextPage = {
            // pathname: "/package-sales-payment",
            pathname: res.data.nextpagepath,
            transactionInfo: TransactionInformation, // your data array of objects
            selectedpackagesInfo: TABLE_DATA,
            pageInfo: {
              navid: navid,
              navname: CurrentPage,
            },
          };
          props.history.push(itemNextPage);
        }
        setisLoaded(false);
      } else {
        setisLoaded(false);
        setShowMsgBox(true);
        setMsg("Missing navigation ID");
        setMsgType("warning");
        setTimeout(() => {
          setShowMsgBox(false);
        }, 3000);
      }
    });
  };
  //ApiData Component useState EOF

  //Message Box
  const [showMsgBox, setShowMsgBox] = useState(false);
  const [msgBoxContent, setMsg] = useState("Empty");
  const [msgType, setMsgType] = useState("success");
  //Message Box EOF

  //Table Settings
  const [TABLE_DATA, setSelectedPackageTable] = useState([]);
  const [selectedPackage, setSelectedPackage] = useState({});
  const [totalCount, setTotalCount] = useState(null);

  const onSelectPackage = () => {
    setShowOverlay(true);
    if(TABLE_DATA.length == Number(totalCount)){
      setShowOverlay(false);
      setOpen(false);
      setPopUpMessage(
        "You have already reach the maximum count of set."
      );
      setModalOpen(true);
      setMessageType("warning");
      return;
    }else{
      const newData = [...TABLE_DATA];
      const neededKeys = ["packageid", "packagename", "packageqty"];
      if (neededKeys.every((key) => Object.keys(selectedPackage).includes(key))) {
        if (selectedPackage.packageqty <= 0) {
          setShowOverlay(false);
          setShowMsgBox(true);
          setMsg("Please select atleast 1 set");
          setMsgType("warning");
          setTimeout(() => {
            setShowMsgBox(false);
          }, 3000);
        }else if(selectedPackage.packageqty > Number(totalCount)){
          setShowOverlay(false);
          setOpen(false);
          setPopUpMessage(
            "You can't add more than the maximum set count"
          );
          setModalOpen(true);
          setMessageType("warning");
        } else {
          if(Number(TABLE_DATA.length) + Number(selectedPackage.packageqty) > Number(totalCount)){
           setShowOverlay(false);
          setOpen(false);
          setPopUpMessage(
            "You can't add more than the maximum set count"
          );
          setModalOpen(true);
          setMessageType("warning");
          return;
          }
  
          for (let i = 0; i < selectedPackage.packageqty; i++) {
            const tempObj = {
              packageid: selectedPackage.packageid,
              packagename: selectedPackage.packagename,
            };
            newData.push(tempObj);
          }
          //get data for warehouse/location dropdown
          const form_data = {
            package_obj: newData,
            packageid: selectedPackage.packageid,
            branchidno: branchIdNo,
          };
  
  
          const formData = new FormData();
          formData.append("form_data", JSON.stringify(form_data));
          const apiUrl = process.env.REACT_APP_API_URL + "checkiteminventory";
          axios.post(apiUrl, formData, { headers: headers }).then((res) => {
            if (res.data.is_insufficient == "no") {
              setSelectedPackageTable([...newData]);
              setShowOverlay(false);
            } else {
              setShowOverlay(false);
              setPopUpMessage(
                "Insufficient inventory quantity for the chosen Wholesale Set. You may contact our head office for your repurchase of products."
              );
              setModalOpen(true);
              setMessageType("warning");
              // setShowMsgBox(true);
              // setMsg(
              //   "Insufficient inventory quantity for the chosen packages. You may contact our head office for your repurchase of products."
              // );
              // setMsgType("warning");
              setTimeout(() => {
                setModalOpen(false);
              }, 3000);
            }
          });
        }
      } else {
        setShowOverlay(false);
        setPopUpMessage("Please select atleast 1 set");
        setModalOpen(true);
        setMessageType("warning");
        // setShowMsgBox(true);
        // setMsg("Please select atleast 1 package");
        // setMsgType("warning");
        setTimeout(() => {
          setModalOpen(false);
        }, 3000);
      }
      setSelectedPackage({});
      handleClose();
    }

  };

  const onPackageSelectionChange = (event) => {
    const newData = { ...selectedPackage };
    newData[event.target.name] = event.target.value;
    setSelectedPackage({ ...newData });
  };

  const refreshTable = () => {
    const newData = [...TABLE_DATA];
    setSelectedPackageTable([...newData]);
  };

  const TABLE_COLUMNS = [
    {
      name: "packageid",
      label: "ID",
    },
    {
      name: "packagename",
      label: "Name",
    },
        {
          name: "action",
          label: "Action",
          options: {
            customBodyRender: (value, tableMeta, updateValue) => {
              const rowIndex = tableMeta.rowIndex;
              return (
                <Button
                  variant="contained"
                  color="secondary"
                  onClick={() => updateSelectedPackages(rowIndex)}
                >
                  Delete
                </Button>
    
              );
            },
          },
        },
  ];

  const TABLE_OPTION = {
    selectableRowsHideCheckboxes: true,
    // selectableRowsOnClick: true,
    print: false,
    filter: false,
    download: false,
    viewColumns: false,
    // onRowsDelete: (data) => {
    //   updateSelectedPayment(data.data[0].dataIndex);
    // },
  };

  const updateSelectedPackages = (index) => {
    TABLE_DATA.splice(index, 1);
    refreshTable();
  };

  const selectLocationProps = {
    options: location_dropdown,
    getOptionLabel: (option) => option.description,
  };
  //Table Settings EOF
  const NumberKeyTrapper = (e) => {
    var a = [];
    var k = e.which;

    for (let i = 48; i < 58; i++) {
      a.push(i);
    }

    if (!(a.indexOf(k) >= 0)) {
      e.preventDefault();
    }
  };
  //Modal Settings
  const [open, setOpen] = useState(false);
  const handleOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };
  //Modal Settings EOF

  //OnLoad Event/Data Fetching SOF
  useEffect(() => {
    console.log("props", props);
    isLoggedIn();
    get_idno_package();
    check_if_have_item();
    get_warehouse();
    get_setpackages();
    //     setisLoaded(true);
  }, []);

  useEffect(() => {
      if(TABLE_DATA.length ==totalCount){
        setBtnDisabled(false);
      }else{
        setBtnDisabled(true);
      }
  }, [TABLE_DATA])
  
  //OnLoad Event/Data Fetching SOF

  //Api Functions SOF
  // Code blocks here
  //Api Request Functions EOF

  const dropDownPackages = {
    options: packages_list,
    getOptionLabel: (option) => option.description,
  };
  //FormData
  const [prep_data, setData] = useState({});
  //FormData EOF
  const nextpage = {
    pathname: "/wholesales-payment/",
    // pathname: nextPagePath,
    transactionInfo: TransactionInformation, // your data array of objects
    selectedpackagesInfo: TABLE_DATA,
    promoInfo: package_details,
    pageInfo: {
      navid: navid,
      navname: CurrentPage,
    },
  };

  const nextpageEncoding = {
    pathname: "/package-sales-packagesitem",
    transactionInfo: TransactionInformation, // your data array of objects
    selectedpackagesInfo: TABLE_DATA,
    pageInfo: {
      navid: navid,
      navname: CurrentPage,
    },
  };
  // return !navid ? (
  //   <Redirect to="/package-sales" />
  // ) : (

  // );
  return (
    <div className="page">
      <PopUpModal
        isOpen={modalOpen}
        onClose={() => setModalOpen(false)}
        message={popUpMessage}
        type={messageType}
      />
      <LoadingOverlay
        active={showOverlay}
        spinner
        text={"Checking Inventory . . ."}
      >
        <div className="page-header">
          <div className="page-icon">
            <LoyaltyTwoTone />
          </div>
          <Breadcrumbs aria-label="breadcrumb">
            <NavLink to="/Wholesale">
              <h4 className="header-title">Wholesale Set</h4>
            </NavLink>
            <Button   style={{
    background: "none",
    border: "none",
    padding: 0,
    minWidth: 0,
    color: "#1976d2", 
    textTransform: "none",
    font: "inherit", 
    cursor: "pointer"
  }} onClick={() => history.goBack()}>
            <h4 className="header-title">{props.location.pageInfo.atype} - {CurrentPage}</h4>
            </Button>
            {/* <NavLink to={`/Wholesale-set/${CurrentPage}`}>
              <h4 className="header-title">{props.location.pageInfo.atype} - {CurrentPage}</h4>
            </NavLink> */}
            <Typography color="textPrimary">Wholesale Set Information</Typography>
          </Breadcrumbs>
        </div>
        <div className="page-container">
          <form noValidate autoComplete="off">
            <MessageBox
              in={showMsgBox}
              content={msgBoxContent}
              type={msgType}
            />
            <Grid
              container
              spacing={2}
              alignItems="center"
              justify="center"
              className={classes.root}
            >
              <Grid item xs={12}>
                <Card>
                  <CardContent>
                    <Grid
                      container
                      spacing={3}
    
                      justify="center"
                    >
                      <Grid item xs="4" sm="4">
                        <h4 className={classes.title}>
                          Wholesaler Information
                        </h4>
                        <TextField
                          label="First Name"
                          variant="standard"
                          type="text"
                          disabled
                          InputProps={{
                            style: { color: "#102027" },
                            disabled: true,
                          }}
                          className={classes.field}
                          defaultValue={TransactionInformation.fname}
                        />
                        <TextField
                          label="Middle Name"
                          variant="standard"
                          type="text"
                          disabled
                          InputProps={{
                            style: { color: "#102027" },
                            disabled: true,
                          }}
                          className={classes.field}
                          defaultValue={TransactionInformation.mname}
                        />
                        <TextField
                          label="Last Name"
                          variant="standard"
                          type="text"
                          disabled
                          InputProps={{
                            style: { color: "#102027" },
                            disabled: true,
                          }}
                          className={classes.field}
                          defaultValue={TransactionInformation.lname}
                        />
                        <TextField
                          label="Date of Birth"
                          variant="standard"
                          type="text"
                          disabled
                          InputProps={{
                            style: { color: "#102027" },
                            disabled: true,
                          }}
                          className={classes.field}
                          defaultValue={TransactionInformation.dob}
                        />
                        <TextField
                          label="Email"
                          variant="standard"
                          type="text"
                          disabled
                          InputProps={{
                            style: { color: "#102027" },
                            disabled: true,
                          }}
                          className={classes.field}
                          defaultValue={TransactionInformation.email}
                        />
                        <TextField
                          label="Contact Number"
                          variant="standard"
                          type="text"
                          disabled
                          InputProps={{
                            style: { color: "#102027" },
                            disabled: true,
                          }}
                          className={classes.field}
                          defaultValue={TransactionInformation.conno}
                        />
                      </Grid>
                      <Grid item xs="4" sm="4">
                        <h4 className={classes.title}>
                          Transaction Information
                        </h4>
                        <TextField
                          label="Transaction Date"
                          variant="standard"
                          type="text"
                          disabled
                          InputProps={{
                            style: { color: "#102027" },
                            disabled: true,
                          }}
                          className={classes.field}
                          defaultValue={TransactionInformation.trandate}
                        />
                        <TextField
                          label="Reference Code"
                          variant="standard"
                          type="text"
                          disabled
                          InputProps={{
                            style: { color: "#102027" },
                            disabled: true,
                          }}
                          className={classes.field}
                          defaultValue={TransactionInformation.refcode}
                        />
                        <TextField
                          label="Activation Code"
                          variant="standard"
                          type="text"
                          disabled
                          InputProps={{
                            style: { color: "#102027" },
                            disabled: true,
                          }}
                          className={classes.field}
                          defaultValue={TransactionInformation.activationcode}
                        />
                        <TextField
                          label="Shipping Charge"
                          variant="standard"
                          type="text"
                          disabled
                          InputProps={{
                            style: { color: "#102027" },
                            disabled: true,
                          }}
                          className={classes.field}
                          defaultValue={TransactionInformation.shippingcharge}
                        />
                      </Grid>
                      <Grid item xs="4" sm="4">
                        <h4 className={classes.title}>
                          Wholesale Set Information
                        </h4>
                        <TextField
                          label="Account Type"
                          variant="standard"
                          type="text"
                          disabled
                          InputProps={{
                            style: { color: "#102027" },
                            disabled: true,
                          }}
                          className={classes.field}
                          defaultValue={props.location.pageInfo.atype}
                        />
                        <TextField
                          label="Account Type Name"
                          variant="standard"
                          type="text"
                          disabled
                          InputProps={{
                            style: { color: "#102027" },
                            disabled: true,
                          }}
                          className={classes.field}
                          defaultValue={props.location.pageInfo.name}
                        />
                        <TextField
                          label="Maximum Set Count"
                          variant="standard"
                          type="text"
                          value={totalCount}
                          disabled
                          InputProps={{
                            style: { color: "#102027" },
                            // disabled: true,
                          }}
                            InputLabelProps={{
                            shrink: true,
                          }}

                          className={classes.field}

                        />
                        <TextField
                          label="Wholesale Set Price"
                          variant="standard"
                          type="text"
                          disabled
                          InputProps={{
                            style: { color: "#102027" },
                            disabled: true,
                          }}
                          className={classes.field}
                          defaultValue={numeral(props.location.pageInfo.price).format('0,0.00')}
                        />
                      </Grid>
                    </Grid>

                  </CardContent>
                </Card>
              </Grid>
              <Grid item xs={12}>
                <Card>
                  <CardContent>
                    <Grid container spacing={2}>
                      <Grid xs={12}>
                        <div className={classes.button}>
                          <Button
                            variant="contained"
                            color="primary"
                            onClick={handleOpen}
                            className={classes.buttonMarginRigh}
                          >
                            Add
                          </Button>
                        </div>
                      </Grid>
                      <Grid item xs={12}>
                        {isLoaded ? (
                          <MUIDataTable
                            title={
                              <div>
                                <div className="table-title">Selected Set</div>
                              </div>
                            }
                            id="table-grid"
                            data={TABLE_DATA}
                            columns={TABLE_COLUMNS}
                            options={TABLE_OPTION}
                          />
                        ) : (
                          <Preloader />
                        )}
                      </Grid>
                    </Grid>
                  </CardContent>
                </Card>
              </Grid>
              <Grid item xs="12" className={classes.buttonContainer}>
                <CustomButton
                disabled={btnDisabled}
                  variant="contained"
                  color="primary"
                  onClick={validate_packagecount}
                  sx={{
                    "&:disabled": {
                      backgroundColor: "lightgray !important",
                      color: "darkgray", 
                    },
                  }}
                >
                  Next
                </CustomButton>
              </Grid>
            </Grid>
            <div>
              <Modal
                aria-labelledby="transition-modal-title"
                aria-describedby="transition-modal-description"
                className={classes.modal}
                open={open}
                onClose={handleClose}
                closeAfterTransition
                BackdropComponent={Backdrop}
                BackdropProps={{
                  timeout: 500,
                }}
              >
                <Fade in={open}>
                  <div className={classes.paper}>
                    <h2 id="transition-modal-title">Add Set</h2>
                    <form action="" className={classes.root}>
                      <Grid container spacing={2} alignItems="center">
                        <Grid
                          item
                          xs={3}
                          style={{ display: "flex", alignItems: "center" }}
                        >
                          <Typography>{"Set"}</Typography>
                        </Grid>
                        <Grid item xs={9}>
                          <Autocomplete
                            {...dropDownPackages}
                            autoComplete
                            includeInputInList
                            className={classes.autoComplete}
                            name="packagename"
                            renderInput={(params) => (
                              <TextField
                                {...params}
                                margin="normal"
                                label="Name"
                                variant="outlined"
                                required="true"
                              />
                            )}
                            onChange={(event, newValue) => {
                              if (!newValue == "" || !newValue == null) {
                                const newData = { ...selectedPackage };
                                newData["packageid"] = newValue.id;
                                newData["packagename"] = newValue.description;
                                setSelectedPackage({ ...newData });
                              } else {
                                setSelectedPackage("");
                              }
                            }}
                          />
                        </Grid>
                        <Grid item xs={3}>
                          <Typography>{"Quantity"}</Typography>
                        </Grid>
                        <Grid item xs={9}>
                          <TextField
                            type="number"
                            required
                            name="packageqty"
                            label="Quantity"
                            variant="outlined"
                            style={{ width: "30%" }}
                            inputProps={{ min: 0, max: 10000 }}
                            onKeyPress={NumberKeyTrapper}
                            onChange={onPackageSelectionChange}
                          />
                        </Grid>
                      </Grid>
                      <div className={classes.button}>
                        <Button
                          variant="contained"
                          onClick={handleClose}
                          className={classes.buttonMarginRight}
                        >
                          Close
                        </Button>
                        <CustomButton
                          variant="contained"
                          color="primary"
                          onClick={onSelectPackage}
                        >
                          Add
                        </CustomButton>
                      </div>
                    </form>
                  </div>
                </Fade>
              </Modal>
            </div>
          </form>
        </div>
      </LoadingOverlay>
    </div>
  );
};

export default WholesalesInformation;
